/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RoleType = {
    type: 'Enum',
} as const;
